import { type FaceTecSDKInstance } from "facetec-sdk";
import createSingleton from "../singleton/createSingleton";

// The FaceTec SDK is a global singleton.
const faceTecSingleton = createSingleton<FaceTecSDKInstance>("facetec");

export default faceTecSingleton;
